import React from 'react';
import { Link } from 'react-router-dom';
import type { CategoriaLiga, CategoriaTorneioVinculada } from '../../../types/categoriaLiga';

// Should (MoSCoW) — não é AC do PRD: rótulo de `nivel` no catálogo, mesmos 8 rótulos em
// Português usados no select de `CategoriaLigaForm.tsx`. Nada renderiza quando `nivel`
// é `null`/`undefined` (CL legada sem nível, AC-3).
const NIVEL_LABELS: Record<string, string> = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  INICIANTE: 'Iniciante',
  INTERMEDIARIO: 'Intermediário',
  PROFISSIONAL: 'Profissional',
};

export interface CategoriaLigaItemProps {
  value: CategoriaLiga;
  onEdit: () => void;
  onDelete: () => void;
  onVerEdicoesVinculadas: () => void;
  /**
   * `undefined` = edições ainda não solicitadas/carregadas para este item (painel
   * fechado). Array (mesmo vazio) = já buscado e o painel deve exibir o resultado.
   */
  edicoesVinculadas?: CategoriaTorneioVinculada[];
  canEdit?: boolean;
}

/**
 * Linha/card do catálogo de CategoriaLiga — recebe tudo por props (nenhuma chamada
 * a service), mirror de `TournamentDiscountItem`.
 *
 * PRPs/plans/categoria-liga-phase-3-frontend.plan.md — Task 5 (Satisfies AC-A1, AC-A4).
 */
const CategoriaLigaItem: React.FC<CategoriaLigaItemProps> = ({
  value,
  onEdit,
  onDelete,
  onVerEdicoesVinculadas,
  edicoesVinculadas,
  canEdit = true,
}) => {
  return (
    <div className="card w-100">
      <div className="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div>
          <h6 className="mb-0">{value.nome}</h6>
          {value.descricao && <p className="text-muted small mb-0">{value.descricao}</p>}
          {value.nivel && (
            <span className="badge bg-light text-dark border">
              Nível {NIVEL_LABELS[value.nivel] ?? value.nivel}
            </span>
          )}
        </div>
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={onVerEdicoesVinculadas}
          >
            Edições Vinculadas
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={onEdit}
            disabled={!canEdit}
          >
            Editar
          </button>
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={onDelete}
            disabled={!canEdit}
          >
            Excluir
          </button>
        </div>
      </div>
      {edicoesVinculadas !== undefined && (
        <div className="card-body pt-0">
          <strong className="d-block mb-1">Edições vinculadas:</strong>
          {edicoesVinculadas.length === 0 ? (
            <p className="text-muted small mb-0">Nenhuma edição vinculada.</p>
          ) : (
            <ul className="mb-0">
              {edicoesVinculadas.map((instancia) => (
                <li key={instancia.id}>
                  <Link
                    to={`/liga/tournament/${instancia.torneio.id}/category/${instancia.id}/manage`}
                  >
                    {instancia.nome} — {instancia.torneio.nome}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default CategoriaLigaItem;
